module.exports = __webpack_public_path__ + "img/license.5445520e.svg";